import React from 'react';
import { WhatsAppManager } from './WhatsAppManager';
import WhatsappTemplates from './WhatsappTemplates';
import type { UserSession } from '../../types';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface WhatsappProps {
  session: UserSession | null;
}

const Whatsapp: React.FC<WhatsappProps> = ({ session }) => {
  // Verificar se usuário é administrador
  const isAdmin = ['administrator', 'admin'].includes(session?.usuario?.role as any);

  if (!isAdmin) {
    return (
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="text-center py-16">
          <ExclamationTriangleIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Acesso Restrito</h2>
          <p className="text-gray-500">
            Apenas administradores podem gerenciar configurações de WhatsApp.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Gerenciador de Conexões WhatsApp */}
      <div className="mb-4">
        <WhatsAppManager isAdmin={true} />
      </div>
      
      {/* Templates de WhatsApp */}
      <div className="flex-1">
        <WhatsappTemplates session={session} />
      </div>
    </div>
  );
};

export default Whatsapp;
